module.exports = __webpack_public_path__ + "img/2019-futsolcourts.71c66bee.jpg";